import fetch from './fetch';

export default {
  fetch,
};



// WEBPACK FOOTER //
// ./src/app/services/bridgeHandoff/index.js